import {
	Box,
	Container,
	Divider,
	Grid,
	Link,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import MinusIcon from '../icons/Minus';

const sections = [
	{
		title: 'About',
		links: [
			{
				title: '昭和女子大学　キャリア支援センター',
				href: '#',
			},
			{
				title: '〒154-8533 東京都世田谷区太子堂１-７−57',
			},
		],
	},
	{
		title: 'Policy',
		links: [
			{
				title: 'プライバシーポリシー',
				href: 'https://office.swu.ac.jp/privacy/',
			},
		],
	},
];

const Footer = (props) => (
	<Box
		sx={{
			backgroundColor: 'background.default',
			pb: 6,
			pt: {
				md: 15,
				xs: 6,
			},
		}}
		{...props}
	>
		<Container maxWidth="lg">
			<Grid container>
				<Grid
					size={{ xs: 12, sm: 4, md: 4 }}
					sx={{
						display: 'flex',
						flexDirection: 'column',
						order: {
							md: 1,
							xs: 4,
						},
					}}
				>
					<Typography color="textSecondary" sx={{ mt: 1 }} variant="caption">
						© Copyright Showa Women's University
					</Typography>
				</Grid>
				{sections.map((section, index) => (
					<Grid
						size={{ xs: 12, sm: 4, md: 4 }}
						key={section.title}
						sx={{
							order: {
								md: index + 2,
								xs: index + 1,
							},
						}}
					>
						<Typography color="textSecondary" variant="overline">
							{section.title}
						</Typography>
						<List disablePadding>
							{section.links.map((link) => (
								<ListItem
									disableGutters
									key={link.title}
									sx={{
										pb: 0,
										pt: 1,
									}}
								>
									<ListItemAvatar
										sx={{
											alignItems: 'center',
											display: 'flex',
											minWidth: 0,
											mr: 0.5,
										}}
									>
										<MinusIcon color="primary" />
									</ListItemAvatar>
									<ListItemText
										primary={
											section.title === 'Policy' ? (
												<Link
													target="_blank"
													href={link.href}
													color="textPrimary"
													variant="subtitle2"
												>
													{link.title}
												</Link>
											) : (
												link.title
											)
										}
									/>
								</ListItem>
							))}
						</List>
					</Grid>
				))}
			</Grid>
			<Divider
				sx={{
					borderColor: (theme) =>
						alpha(theme.palette.primary.contrastText, 0.12),
					my: 6,
				}}
			/>
			<Typography color="textSecondary" variant="caption">
				All Rights Reserved.
			</Typography>
		</Container>
	</Box>
);

export default Footer;
